export default {
	init() {
    var ppp = 12; // Post per page
    var pageNumber = 1;


    function load_posts() {
      $("#load-more").text('Loading...');
      pageNumber += 12;
      console.log(pageNumber);
      var str = '&pageNumber=' + pageNumber + '&ppp=' + ppp + '&action=more_post_ajax';
      $.ajax({
        type: "POST",
        dataType: "html",
        url: ajax_posts.ajaxurl,
        data: str,
        success: function(data) {
          var $data = $(data);
          if($data.length) {
            $("#moreIssues").append($data);
            $("#load-more").attr("disabled", false);
          } else {
            $("#load-more").attr("disabled", true);
            $("#load-more").attr("style", "opacity, 0.5");
            $("#load-more").attr("cursor", "not-allowed");
          }
          $("#load-more").text('Load more');
        },
        error : function(jqXHR, textStatus, errorThrown) {
          $loader.html(jqXHR + " :: " + textStatus + " :: " + errorThrown);
        },

      });
      return false;
    }

    $("#load-more").on("click", function(event) {
      event.preventDefault();
      $("#load-more").attr("disabled", true);
      load_posts();
      $(this).insertAfter('#moreIssues');
    });

    // Filtering

    $('.filters select').on('change', function(event) {
      filterBy($(this));
      // $(this)[0].selectedIndex = 0;
    });

    function filterBy(val) {
      let nm = val.attr('name');
      let v = val.val();
      console.log('[data-'+nm+'='+v+']');
      document.location.href = '/issues/?' + nm + '=' + v;

   }

 },
 finalize() {
 },
};



// WEBPACK FOOTER //
// ./scripts/routes/templateIssues.js